<template>
  <BaseConfirmModal
    :visible="!!pending"
    :title="title"
    :body-text="pending?.options.message"
    :button-title="buttonTitle"
    :delete="isDanger"
    :btn-color="isDanger ? 'danger' : 'primary'"
    :base-icon="isDanger ? 'trash' : 'copy'"
    @confirm="onConfirm"
    @hidden="onCancel"
  />
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useConfirm } from '@/composables/useConfirm'

const { t } = useI18n()
const { pending, onConfirm, onCancel } = useConfirm()

const isDanger = ref(true)
const title = ref(t('Are you sure?'))
const buttonTitle = ref(t('Delete'))

watch(pending, (newPending) => {
  if (newPending !== null) {
    isDanger.value = newPending.options.danger !== false
    title.value = newPending.options.title ?? t('Are you sure?')
    buttonTitle.value = newPending.options.buttonTitle ?? t('Delete')
  }
})
</script>
